export default "__VITE_ASSET__DRnU_pV___"